module.exports = __webpack_public_path__ + "media/stylesheets/resident/images/dummy-evt2-30809d586abbc3925781d8ed1fa03de8.jpg";